<big-ui-card
    [hasLink]="!!data.link"
    [isComplex]="true">
    <div
        *transloco="let t; prefix: 'uiCard'"
        [class]="classList"
        [class.flex-row]="cardIndex % 3 > 0"
        [class.md:flex-col]="cardIndex % 3 < 2"
        [class.md:flex-row]="cardIndex % 3 === 2"
        [class.lg:flex-col]="cardIndex % 5 < 3"
        [class.lg:flex-row]="cardIndex % 5 >= 3">
        <div class="block md:hidden">
            <big-ui-picture
                [pictureClass]="'aspect-3/2'"
                [model]="data.image"
                class="block overflow-hidden"
                [class]="cardIndex % 3 > 0 ? 'w-[120px] rounded-br-2xl' : 'w-full'" />
        </div>
        <div class="hidden md:block lg:hidden">
            <big-ui-picture
                [pictureClass]="cardIndex % 3 === 2 ? 'aspect-1/1' : 'aspect-3/2'"
                [model]="data.image"
                class="block"
                [class]="cardIndex % 3 === 2 ? 'w-[251px]' : 'w-full'" />
        </div>
        <div class="hidden lg:block">
            <big-ui-picture
                [pictureClass]="cardIndex % 5 >= 3 ? 'aspect-1/1' : 'aspect-3/2'"
                [model]="data.image"
                class="block"
                [class]="cardIndex % 5 >= 3 ? 'w-[251px]' : 'w-full'" />
        </div>
        <div class="flex h-full flex-col p-4 md:p-6 gap-2">
            @if (data.subjectAreas) {
                <ul
                    class="mb-2 md:flex flex-wrap gap-2"
                    [class.flex]="cardIndex % 3 === 0"
                    [class.hidden]="cardIndex % 3 > 0">
                    @for (subjectArea of data.subjectAreas; track $index) {
                        <li>
                            <big-ui-tag [classList]="'!text-primary !bg-primary-50' + (subjectArea.id === selectedAreaId ? ' border-2 border-primary' : '')">
                                <span [innerHTML]="subjectArea.name | sanitize: securityContext"></span>
                            </big-ui-tag>
                        </li>
                    }
                </ul>
            }
            <h5 class="mb-0">{{ data.title }}</h5>
            <span class="text-sm">{{ data.changed | date: 'dd. MMMM yyyy' }}</span>
        </div>
        @if (data.link) {
            <big-ui-link
                class="text-primary"
                [href]="data.link.href"
                [srOnly]="true"
                [linkClass]="'static flex items-center font-bold no-underline after:absolute after:inset-0 after:rounded-none'">
                {{ t('linkTitle', { nodeTitle: data.title }) }}
            </big-ui-link>
        }
    </div>
</big-ui-card>
